var mod;

mod = angular.module('gym.classroom', ['model']);

// coffeelint: disable
mod.factory('Classroom', ["Model", function(Model) {
  var Classroom;
  return Classroom = (function() {
    class Classroom extends Model {
      gymId() {
        return this.gym().id();
      }

    };

    Classroom.param = 'classroom';

    Classroom.prototype.gym = Classroom.prototype.parent;

    return Classroom;

  }).call(this);
}]);

// coffeelint: enable
mod.controller('ClassroomMgmtModalCtrl', ["classrooms", "$scope", "$rootScope", "$modalInstance", "Locations", "SubscriptionPlanLimitService", function(classrooms, $scope, $rootScope, $modalInstance, Locations, SubscriptionPlanLimitService) {
  var loadLocations;
  loadLocations = function() {
    return Locations.getList({
      count: 1000
    }).then(function(locations) {
      $scope.classrooms = _.sortBy(locations, function(location) {
        return !location.active;
      });
      return $rootScope.gym.locations = _.sortBy(locations.plain(), function(location) {
        return !location.active;
      });
    });
  };
  $scope.newRoom = {};
  loadLocations();
  $scope.displayName = function(location) {
    if (location.active) {
      return location.name;
    } else {
      return `[Deactivated] ${location.name}`;
    }
  };
  $scope.ok = function() {
    return $modalInstance.close();
  };
  $scope.saveLocation = function(location) {
    return location.save().then(function() {
      return loadLocations();
    });
  };
  $scope.resetLocation = function(location) {
    angular.extend(location, $scope.tempLocation);
    return location._edit = void 0;
  };
  $scope.editLocation = function(location) {
    $scope.tempLocation = angular.extend({}, location.plain());
    return location._edit = true;
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.createLocation = function() {
    return Locations.post($scope.newRoom).then(function() {
      $scope.error = void 0;
      $scope.newRoom = {};
      return loadLocations();
    }, function(response) {
      return SubscriptionPlanLimitService.validate(response.data);
    });
  };
  $scope.reactivateLocation = function(location) {
    location.active = true;
    return $scope.saveLocation(location);
  };
  return $scope.deleteLocation = function(location) {
    if (window.confirm("Are you sure?")) {
      $scope.error = void 0;
      return location.remove().then(function() {
        return loadLocations();
      }, function() {
        return $scope.error = 'This location is in use and cannot be deleted at this time.';
      });
    }
  };
}]);
